import React from 'react';
import { Panel, Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
    getSettings,
    updateSettings,
    clearUpdateSettings,
    deleteSettings,
    clearDeleteSettings
} from '../../../actions/settings';
import { Table } from './Table'
import { promo as promoType } from '../../../constants/settingTypes';
import EditModal from './EditModal';
import * as permissions from '../../../constants/permissions';
import ConfirmModal from '../../common/ConfirmModal'
import moment from 'moment';

let PromoImage = class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAddModal: false,
            showUpdateModal: false,
            confirmModalShow: false,
            promoToEdit: null,
            promoToAdd:null,
            isMultiple: true,
            promoCollection:[],
        }

        this._load = this._load.bind(this);
        this._onAddClick = this._onAddClick.bind(this);
        this._onEditClick = this._onEditClick.bind(this);
        this._onClose = this._onClose.bind(this);
        this._addPromo = this._addPromo.bind(this);
        this._updatePromo= this._updatePromo.bind(this);

        this._onDeleteClick = this._onDeleteClick.bind(this);
        this._onDeleteCanceled = this._onDeleteCanceled.bind(this);
        this._onDeleteConfirmed = this._onDeleteConfirmed.bind(this);

    }

    componentDidMount() {
        this._load();
    }

    _load() {
        this.props.getSettings(promoType);
    }

    _onAddClick() {
        this.props.clearUpdateSettings(promoType);
        let promo = {PositionIndex: 1}
        this.setState({ promoToAdd : promo ,showAddModal: true });
    }

    _addPromo(promoModel) {
        this.props.updateSettings(promoType, promoModel,undefined,undefined,this.state.isMultiple);
    }

    _onClose() {
        this.setState({
            showAddModal: false,
            promoToEdit: null,
            showUpdateModal: false
        });
        this.props.clearUpdateSettings(promoType);
    }

    _onEditClick(promoModel) {
        this.setState({ promoToEdit: promoModel, showUpdateModal: true })
    }
    
    _onDeleteClick(promoToDelete) {
        this.setState({ promoToDelete, confirmModalShow: true });
    }
     _onDeleteCanceled() {
        this.setState({ promoToDelete: null, confirmModalShow: false });
        this.props.clearDeleteSettings(promoType);
    }

    _onDeleteConfirmed() {
        this.props.deleteSettings(promoType ,{Id :this.state.promoToDelete.Id});
    }

    _updatePromo(promoModel) {
        this.props.updateSettings(promoType, promoModel, promoModel.Id, undefined,this.state.isMultiple);
    }

    render() {
        const { promos: { data, fetching,deleteFetching } } = this.props;
        const { showAddModal, showUpdateModal, promoToEdit, promoToAdd } = this.state;
        const modalProps = {
            isNew: showAddModal,
            initialValues: promoToEdit ? promoToEdit : {

                IsDisplay:true
            },
            listData:data,
            onClose: this._onClose,
            onSubmit: showAddModal ? this._addPromo : this._updatePromo
        };
        const isReadOnly = !permissions.isAllowedFor(permissions.allowedEditSettings);
        const addByttonClass = `add-glyph${isReadOnly ? '.disabled' : ''}`;
        this.promoCollection = data;
        
        return (
            <Panel>
                <Panel.Heading >
                    <span>Акции</span>
                    <Glyphicon
                        glyph='plus'
                        title='Добавить'
                        className={addByttonClass} style={{ float: 'right' }}
                        onClick={isReadOnly ? undefined : this._onAddClick} />
                </Panel.Heading>
                <Panel.Body className='box-container'>
                    <Table
                        fetching={fetching}
                        deleteFetching={deleteFetching}
                        promos={data}
                        onEdit={this._onEditClick}
                        onDelete ={this._onDeleteClick}
                        isReadOnly={isReadOnly} />
                    {(showAddModal || showUpdateModal) && <EditModal {...modalProps} />}
                    {this.state.confirmModalShow &&
                        <ConfirmModal
                            onYes={this._onDeleteConfirmed}
                            onNo={this._onDeleteCanceled}
                            fetching={deleteFetching}
                            message={`Удалить Акцию под Id ${moment(this.state.promoToDelete.Id)}?`}
                            title="Вы уверены?"
                            show={true} />}
                </Panel.Body>
            </Panel>
        );
    }
}
PromoImage = connect(state => {
    return { promos: state.application.get('settings')[promoType] };
}, { getSettings, updateSettings, clearUpdateSettings, deleteSettings ,clearDeleteSettings})(PromoImage);

export default PromoImage;


// WEBPACK FOOTER //
// ./src/components/settings/promo/PromoImage.jsx